import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { LOCALE_ID } from '@angular/core';
import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  includeBearerTokenInterceptor
} from 'keycloak-angular';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';

import { routes } from '../routes';
import { loadingInterceptorFn } from '../interceptors/loading.interceptor';
import { errorInterceptorFn } from '../interceptors/error.interceptor';
import { KeycloakInfoService } from '../shared/services/keycloak-info.service';
import { ALL_ICONS, provideIconSet } from '@pansa/ui';
import { provideKeycloakAngular } from './keycloak.config';
import { provideQuillConfig } from 'ngx-quill/config';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /.*/,
  bearerPrefix: 'Bearer'
});


export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloakAngular(),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition]
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideIconSet({ icons: [...ALL_ICONS] }),
    provideRouter(routes),
    provideHttpClient(
      withXhr(),
      withInterceptors([includeBearerTokenInterceptor, loadingInterceptorFn, errorInterceptorFn])
    ),
    provideQuillConfig({
      modules: {
        syntax: false,
        toolbar: [
          ['bold', 'italic', 'underline'],

          [{ header: [1, 2, 3, false] }],

          [{ list: 'ordered' }, { list: 'bullet' }],

          [{ color: [] }, { background: [] }],

          [{ align: [] }],

          ['link'],

          ['clean']
        ]
      }
    }),
    { provide: LOCALE_ID, useValue: 'pl' },

    KeycloakInfoService
  ]
};
